var GoogleMapsLoader = require('google-maps');
require('select2');
require('select2/dist/css/select2.min.css');

function changeContact(idContact, isInit) {

	// For Tech Ask, show product form
	if( idContact == 4)
		$('.contact_tech_product_search').addClass('active');
	else
		$('.contact_tech_product_search').removeClass('active');

	// For Partner Ask, show products form
	if( idContact == 5)
		$('.contact_partner_product_search').addClass('active');
	else
		$('.contact_partner_product_search').removeClass('active');

	$.ajax({
		type: 'POST',
		url: baseUri + '?rand=' + new Date().getTime(),
		async: true,
		cache: false,
		dataType : "json",
		headers: { "cache-control": "no-cache" },

		data:
		{
			controller: 'contact',
			submitChangeContact: 1,
			ajax: true,
			token: token,
			idContact: idContact
		},

		success: function(jsonData)
		{
			if (jsonData.hasError)
			{
				var errors = '';
				for(error in jsonData.errors)
					//IE6 bug fix
					if(error != 'indexOf')
						errors += '<li>' + jsonData.errors[error] + '</li>';
				$('#create_account_error').html('<ol>' + errors + '</ol>').show();
			}

			else
			{
				var options_contact = "<option value='-1'>Choisissez un objet</option>";
				$.each(jsonData["options"], function(index, value)
				{
					options_contact += "<option value='" + index + "'>" + value + "</option>";
				});

				$('#demand_type').html(options_contact);

				if(isInit) {
					$('#demand_type').find('option[value='+$('input[name=old_demand_type]').val()+']').attr('selected', 'selected');
				}

			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown)
		{
			error = "TECHNICAL ERROR: unable to load form.\n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus;
			if (!!$.prototype.fancybox)
			{
				$.fancybox.open([
				{
					type: 'inline',
					autoScale: true,
					minHeight: 30,
					content: "<p class='fancybox-error'>" + error + '</p>'
				}],
				{
					padding: 0
				});
			}
			else
				alert(error);
		}
	});
}

function showProductSelect(idOrder)
{
	$('.product_select').hide().prop('disabled', 'disabled').parent('.selector').hide();
	$('.product_select').parents('.form-group:first').find('label').hide();
	if ($('#' + idOrder + '_order_products').length > 0)
	{
		$('#' + idOrder + '_order_products').removeProp('disabled').show().parent('.selector').removeClass('disabled').show();
		$('.product_select').parents('.form-group:first').show().find('label').show();
	}
}

function formatProduct (product) {

  if (product.loading) return product.text;
  var markup = "<div class='select2-result-repository clearfix'>" + product.cname + ' > '+ product.pname + "</div>";
  return markup;

}

function formatProductSelection (product) {
  return product.pname;
}

function initContact()
{
	if( $('.contact_form_container').length ){

		var url = new URL(window.location.href);
		var contact_param = url.searchParams.get('contact');
		if( contact_param == 'SAV' ) {
			$('select[name=id_contact]').val(4);
			$('input[name=old_demand_type]').val(0);
		}

		$('select[name=id_contact]').on('change', function() {
			changeContact($(this).val(), false);
		});

		$(document).on('change', 'select[name=id_order]', function (){
			showProductSelect($(this).attr('value'));
		});

		changeContact($('select[name=id_contact]').val(), true);
		showProductSelect($('select[name=id_order]').attr('value'));

		$(".contact_product_autocomplete").select2({
		  ajax: {
		    url: $('#product_search_url').val(),
		    dataType: 'json',
		    delay: 250,
		    data: function (params) {
		      return {
		        q: params.term, // search term
		        page: params.page,
				ajaxSearch: 1,
				id_lang: id_lang,
				current_page: 'contact'
		      };
		    },
		    processResults: function (data, params) {

		      params.page = params.page || 1;

		      if( data.length){
		      	$.each(data, function(index, val) {
		      		val.id = val.id_product;
		      	});
		      }
		      return {
		        results: data,
		        pagination: {
		          more: (params.page * 30) < data.length
		        }
		      };
		    },
		    cache: true
		  },
		  escapeMarkup: function (markup) {
		  	return markup;
		  },
		  minimumInputLength: 1,
		  templateResult: formatProduct,
		  templateSelection: formatProductSelection,
		  language: "fr",
		  language: {
			  inputTooShort: function(message) {
			  	return "Commencez à entrer le nom du produit";
			  },
		  }
		});

	}

}

module.exports = initContact;


// WEBPACK FOOTER //
// ./js/contact.js